import { apis } from '.';
import http from './http';

export default class OpenOtherApi { 
  /**
   * @description 获取oem配置信息
   */ 
  static getOemConfig () {
    return http.get(apis.verify_oem_config)
  }

  /**
   * @description 获取oem
   * */ 
  static getOemHelpdocUrl (type: string) {
    return http.get(apis.get_oem_helpdoc_url, { type })
  }

  /**
   * @description 保存oem
   * */ 
  static saveOemHelpdocUrl (param: any) {
    return http.post(apis.save_oem_helpdoc_url, param)
  }

  /**
   * @description 获取客服信息
   * */ 
  static getEngineerInfo (id: number) {
    return http.get('api/v1/engineers/' + id + '.json')
  }

  /**
   * @description 添加tag
   * */ 
   static addTag (name: string) {
    return http.post(apis.add_tag, { name })
  }

  /**
   * @description 获取tag
   * */ 
  static getTags (keyword: string) {
    return http.get(apis.tags_by_key + '?count=10&key=' + keyword)
  }

  static getTicketTags () {
    return http.get(apis.ticket_r_tag)
  }

  static getUserTags () {
    return http.get(apis.user_r_tag)
  }

  static getUserGroupTags () {
    return http.get(apis.user_group_r_tag)
  }

  static deleteUserRelationTag (param: {
    tagId: number,
    userId: number
  }) {
    return http.post(apis.delete_user_tag_relation, param)
  }

  static deleteTicketRelationTag (param: {
    tagId: number,
    tagName?: string,
    ticketId: number
  }) {
    return http.post(apis.delete_ticket_tag_relation, param)
  }

  static deleteUserGroupRelationTag (param: {
    tagId: number,
    userGroupId: number
  }) {
    return http.post(apis.delete_user_group_tag_relation, param)
  }
  
  static deleteChatRelationTag (param: {
    tagId: number,
    chatId: number
  }) {
    return http.post(apis.delete_chat_tag_relation, param)
  }

  static saveUserRelationTag (param: {
    tagId: number,
    userId: number
  }) {
    return http.post(apis.save_user_tag_relation, param)
  }

  static saveTicketRelationTag (param: {
    tagId: number,
    tagName?: string,
    ticketId: number
  }) {
    return http.post(apis.save_ticket_tag_relation, param)
  }

  static saveUserGroupRelationTag (param: {
    tagId: number,
    userGroupId: number
  }) {
    return http.post(apis.save_user_group_tag_relation, param)
  }
  
  static saveChatRelationTag (param: {
    tagId: number,
    chatId: number
  }) {
    return http.post(apis.save_chat_tag_relation, param)
  }

  static updateEngineer (param: {
    engineer: any,
    oldValid?: boolean
  }) {
    return http.post(apis.update_engineer, param)
  }

  static saveEngineer (param: {
    defaultServiceDesk: { id: number },
    maxConcurrentChatNumber: number,
    minConcurrentChatNumber: number,
    nickname: string,
    role: { id: number },
    serviceDesks: Array<any>,
    user: {
      email?: string,
      name: string,
      tags: Array<any>,
      status: number
    }
  }) {
    return http.post(apis.save_engineer, param)
  }

  static getCustomFields (param: {
    userId: number,
    scope: string
  }) {
    return http.get(apis.user_custom_field, param)
  }

  static updateUserCustomFields (param: Array<any>) {
    return http.post(apis.updateUserCustomFields, param)
  }

  static batchUpdateEngineers (params: {
    ids: string,
    engineer: {
      defaultServiceDesk: { id: number },
      maxConcurrentChatNumber: number,
      minConcurrentChatNumber: number,
      role: { id: number },
      serviceDesks: Array<any>, // { id }
      user: { tags: Array<any> }
    }
  }) {
    return http.post(apis.batch_update_engineers, params)
  }

  static sendResetPasswordEmail (params: {
    email: string
  }) {
    return http.get(apis.send_reset_password_email, params)
  }

  /** 
   * @description 获取自定义字段
   * @param scope 'engineer':获取客服的自定义字段 'user':获取客户的自定义字段
   * 
   */
  static getCustomField (scope: string) {
    return http.get(apis.custom_field, { scope })
  }

  /**
   * @param userIds 用户ID，','连接
   * @param customFieldIds 自定义字段ID，','连接
   */
  static getCustomFieldValue (params: {
    userIds: string
    customFieldIds: string
  }) {
    return http.get(apis.custom_field_value, params)
  }
}
